var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidebar-logo-container", class: { collapse: true } },
    [
      _c("transition", { attrs: { name: "sidebarLogoFade" } }, [
        _c(
          "div",
          {
            staticClass:
              "sidebar-logo-container flex align-center justify-center cursor-pointer",
            on: { click: _vm.gotoBase },
          },
          [
            _c("img", {
              staticClass: "sidebar-logo",
              attrs: { src: require("@/assets/list/logo.png"), alt: "" },
            }),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }